import { getDeviceId } from '../getDeviceId';

/**
 * Ensures a `device_id` cookie exists, minting one server-side when it doesn't.
 *
 * Skipped entirely when the cookie is already present, so only cold visits pay
 * for the request. Failures are swallowed: a missing device id degrades
 * `identifyUser` to a plain `identify` rather than breaking the page.
 */
export const ensureDeviceId = async (): Promise<void> => {
	if (getDeviceId()) {
		return;
	}

	try {
		await fetch('/api-svelte/device-id', { method: 'POST' });
	} catch {
		// Analytics plumbing must never surface an error to the user.
	}
};
